export default __webpack_public_path__ + "static/media/1.49a0d67d.png";